// I18n
import { useI18n } from "vue-i18n";

// Store
import { storeToRefs } from "pinia";
import { useSessionStore } from "@store";

// Types
import type { Reasons } from "./planCancellation.types";

export const getReasons = (): Reasons => {
  const { t } = useI18n();
  const sessionStore = useSessionStore();
  const { session } = storeToRefs(sessionStore);
  const isMasterUser = session.value?.isMasterUser;

  let reasons: Reasons = [
    {
      key: "too_expensive",
      value: t("reasons.too_expensive.label"),
      data: {
        validOption: true,
        showComment: false,
        showContactSupport: true,
        showWarning: false,
      },
    },
    {
      key: "bad_results",
      value: t("reasons.bad_results.label"),
      data: {
        validOption: true,
        showComment: true,
        showContactSupport: true,
        showWarning: false,
      },
    },
    {
      key: "missing_features",
      value: t("reasons.missing_features.label"),
      data: {
        validOption: true,
        showComment: true,
        showContactSupport: false,
        showWarning: false,
      },
    },
    {
      key: "too_busy",
      value: t("reasons.too_busy.label"),
      data: {
        validOption: true,
        showComment: false,
        showContactSupport: true,
        showWarning: false,
      },
    },
    {
      key: "bad_experience",
      value: t("reasons.bad_experience.label"),
      data: {
        validOption: true,
        showComment: true,
        showContactSupport: false,
        showWarning: false,
      },
    },
    {
      key: "business_close",
      value: t("reasons.business_close.label"),
      data: {
        validOption: true,
        showComment: false,
        showContactSupport: false,
        showWarning: false,
      },
    },
  ];

  if (isMasterUser) {
    reasons = [
      {
        key: "defaulter",
        value: t("reasons.defaulter.label"),
        data: {
          validOption: true,
          showComment: true,
          showContactSupport: false,
          showWarning: false,
        },
      },
      {
        key: "fraud",
        value: t("reasons.fraud.label"),
        data: {
          validOption: true,
          showComment: true,
          showContactSupport: false,
          showWarning: false,
        },
      },
      {
        key: "account_change",
        value: t("reasons.account_change.label"),
        data: {
          validOption: true,
          showComment: true,
          showContactSupport: false,
          showWarning: false,
        },
      },
      {
        key: "seasonality",
        value: t("reasons.seasonality.label"),
        data: {
          validOption: true,
          showComment: true,
          showContactSupport: false,
          showWarning: false,
        },
      },
      {
        key: "tiendanube_close",
        value: t("reasons.tiendanube_close.label"),
        data: {
          validOption: true,
          showComment: false,
          showContactSupport: false,
          showWarning: false,
        },
      },
      {
        key: "audited",
        value: t("reasons.audited.label"),
        data: {
          validOption: true,
          showComment: true,
          showContactSupport: false,
          showWarning: false,
        },
      },
      ...reasons,
    ];
  }
  return reasons;
};
